module.exports = __webpack_public_path__ + "img/htu-2-1.4970497a.png";